/** Shared URL storage — same key as legacy my-deck / profile referral flows. */
export const FAN_CARD_REDIRECT_URL_KEY = "fanCardRedirectUrl";

/** Distinguishes which handler runs after redirect when URLs overlap. */
export const FAN_CARD_REDIRECT_FLOW_KEY = "fanCardRedirectFlow";

/** Query param on attic collection share links. */
export const FAN_CARD_FLOW_QUERY_PARAM = "fanCardFlow";

export const FAN_CARD_FLOW_COLLECTION = "collection";
export const FAN_CARD_FLOW_REFERRAL = "referral";
export const FAN_CARD_FLOW_DECK = "deck";

export const getFanCardRedirectFlow = (): string | null =>
  localStorage.getItem(FAN_CARD_REDIRECT_FLOW_KEY);

export const isFanCardCollectionFlow = (): boolean =>
  getFanCardRedirectFlow() === FAN_CARD_FLOW_COLLECTION;

export const isFanCardCollectionUrl = (url: string): boolean => {
  try {
    const parsed = new URL(url, window.location.origin);
    return (
      parsed.searchParams.get(FAN_CARD_FLOW_QUERY_PARAM) ===
      FAN_CARD_FLOW_COLLECTION
    );
  } catch {
    return false;
  }
};

export const setFanCardRedirect = (url: string, flow?: string): void => {
  localStorage.setItem(FAN_CARD_REDIRECT_URL_KEY, url);
  if (flow) {
    localStorage.setItem(FAN_CARD_REDIRECT_FLOW_KEY, flow);
  }
};

export const clearFanCardRedirectFlow = (): void => {
  localStorage.removeItem(FAN_CARD_REDIRECT_FLOW_KEY);
};

export const clearFanCardRedirect = (): void => {
  localStorage.removeItem(FAN_CARD_REDIRECT_URL_KEY);
  clearFanCardRedirectFlow();
};

/** Clear stored URL before redirect; keep flow flag for collection dialog. */
export const prepareFanCardPostLoginRedirect = (): void => {
  localStorage.removeItem(FAN_CARD_REDIRECT_URL_KEY);
  if (!isFanCardCollectionFlow()) {
    clearFanCardRedirectFlow();
  }
};

export const storeFanCardRedirectFromUrl = (url: string): void => {
  if (url.includes("/sign-in") || url.includes("/register")) return;

  const flow = isFanCardCollectionUrl(url)
    ? FAN_CARD_FLOW_COLLECTION
    : undefined;

  if (flow) {
    setFanCardRedirect(url, flow);
  } else {
    localStorage.setItem(FAN_CARD_REDIRECT_URL_KEY, url);
  }
};
